<div class="reading-page doc-page">
  <div id="head" class="section-header">
    <h2 class="section-title">Terms of Sale</h2>
    <h3 class="section-description">Premium theme downloads sold on {{ environmentCommon.company.website }}</h3>
  </div>
  <app-policy-card [policyBody]="body">
    <!-- Body -->
    <ng-template #body>
      <div class="policy-content">
        <p class="policy-updated">Last updated: {{ lastUpdated }}</p>

        <p>These Terms of Sale apply to every purchase of a premium theme download (a "Product") from the store on
          {{ environmentCommon.company.website }} (the "Store"). By placing an order you agree to them. They sit
          alongside our general <a [routerLink]="URLS.terms">Terms &amp; Conditions</a> and
          <a [routerLink]="URLS.privacyPolicy">Privacy Policy</a>; where they differ, these Terms of Sale apply to
          Store purchases.</p>

        <p><strong>1. Who you are buying from</strong></p>
        <p>The Store is operated by Codigrate OÜ, a private limited company registered in Estonia ("{{ BRAND.name }}",
          "we", "us"). You can reach us at <a [href]="'mailto:' + environmentCommon.company.email">{{ environmentCommon.company.email }}</a>
          or through the <a [routerLink]="URLS.contactUs">contact page</a>. Payments are processed by Stripe; where
          Stripe acts as the merchant of record for your purchase, your receipt and invoice say so and are issued by
          Stripe on our behalf.</p>

        <p><strong>2. What you buy</strong></p>
        <p>A Product is digital content: the theme files for the platform named on the listing (for Sublime Text, the
          colour scheme and the window theme), delivered as a downloadable archive together with install
          instructions. A Product is sold for a one-time price; there is no subscription and nothing renews. The
          listing describes what the archive contains and its current version. Your order always gives you the latest
          version of the Product: when we release an update, the download links on your order page deliver it at no
          extra cost. Earlier versions are not kept.</p>

        <p><strong>3. Ordering and payment</strong></p>
        <p>You add Products to your cart and pay through Stripe Checkout. Your order is accepted, and the contract
          formed, when the payment is confirmed; you then see an order number and receive an e-mail. The prices shown in
          the Store include VAT or sales tax where it applies. Stripe shows the exact amount in your currency before you
          pay. We do not store your card details; Stripe handles them under its own terms and privacy policy. Promotion
          codes can be entered at checkout and cannot be applied afterwards.</p>

        <p><strong>4. Delivery</strong></p>
        <p>Delivery is immediate. As soon as the payment is confirmed the download buttons appear on your order page,
          and the same links are e-mailed to the address you gave at checkout. Each download link is valid for one
          hour; opening your order page issues fresh ones at any time. Your order page is reached through a private
          link. It is your access to the files, so keep it to yourself. If you lose it, the
          <a [routerLink]="URLS.orderFind">Find my order</a> page e-mails it again to the address you paid with. Each
          Product may be downloaded a reasonable number of times per order; if you reach the limit, contact us with your
          order number and we will reset it.</p>

        <p><strong>5. No refunds; your right of withdrawal</strong></p>
        <p>Because a Product is digital content that is delivered immediately and cannot be returned, all sales are
          final. At checkout you tick a box by which you expressly request immediate delivery and acknowledge that you
          lose your right of withdrawal once delivery has begun (Article 16(m) of Directive 2011/83/EU and the
          corresponding provision of Estonian law). We therefore do not offer refunds, exchanges or cancellations
          after payment. This does not affect your statutory rights if a Product is faulty: if the files do not work as
          described and we cannot put that right, you may be entitled to the remedies your local consumer law provides.
          Tell us at <a [href]="'mailto:' + environmentCommon.company.email">{{ environmentCommon.company.email }}</a>
          and we will help.</p>

        <p><strong>6. Licence</strong></p>
        <p>When your payment is confirmed we grant you a personal, perpetual, non-exclusive, non-transferable licence to
          install and use the Product on any number of devices that you personally use. Each copy you buy covers one
          person; a business that buys for several people buys one copy per person. You may adjust the files for your
          own use. You may not sell, rent, lend, share, publish, upload, redistribute or sublicense the Product or any
          part of it, include it in another product, template or theme pack, or remove or change the copyright notices
          in the files. Sharing the files or your order link with others is a breach of this licence and ends it.</p>

        <p><strong>7. Intellectual property</strong></p>
        <p>The Products, their names, artwork and colour designs are the property of Codigrate OÜ and are protected by
          copyright and other intellectual property laws. Buying a Product transfers no ownership of it to you; you
          receive only the licence in section 6. Platform names such as Sublime Text belong to their respective
          owners and are used to identify compatibility only.</p>

        <p><strong>8. Warranty and liability</strong></p>
        <p>We make the Products with care and test them on the platform versions named on the listing. Beyond your
          statutory rights, the Products are provided "as is": we do not promise that they suit every purpose, work
          with every plugin or future version of the platform, or are free of every defect. To the extent permitted by
          law, our liability for a purchase is limited to the amount you paid for it, and we are not liable for indirect
          or consequential loss. Nothing in these terms limits liability that cannot be limited under applicable law,
          including your mandatory consumer rights.</p>

        <p><strong>9. Support</strong></p>
        <p>Questions about an order, a download or an install go to
          <a [href]="'mailto:' + environmentCommon.company.email">{{ environmentCommon.company.email }}</a>. Please quote
          your order number (CG-…). We answer within a few working days.</p>

        <p><strong>10. Changes to these terms</strong></p>
        <p>We may update these Terms of Sale; the version in force when you place an order is the one that applies to
          that order. The date at the top tells you when they last changed.</p>

        <p><strong>11. Governing law</strong></p>
        <p>These Terms of Sale are governed by the laws of Estonia. If you are a consumer in the European Union or the
          United Kingdom, you also keep the protection of the mandatory rules of the country where you live, and you may
          bring a claim in its courts. Disputes are first raised with us by e-mail; we try to settle them amicably.</p>
      </div>
    </ng-template>
  </app-policy-card>
</div>
